import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AssignToMeState } from './assign-to-me.types';

const assignToMeFeatureSelector = createFeatureSelector<AssignToMeState>('assignToMe');

export const selectAssignToMeUpdating = createSelector(
  assignToMeFeatureSelector,
  state => state.updating
);

export const selectAssignToMeUpdated = createSelector(
  assignToMeFeatureSelector,
  state => state.updated
);

export const selectAssignToMeData = createSelector(
  assignToMeFeatureSelector,
  state => state.data
);

export const selectAssignToMeError = createSelector(
  assignToMeFeatureSelector,
  state => state.error
);
